import { Modal, useMantineTheme } from "@mantine/core";
import React, { useState } from "react";
import { ScriptModalProps } from "../../../../../../types/types";
import ScriptEditor from "../editor/ScriptEditor";
import ScriptExecutor from "../scriptExecutor/scriptExecutor";
import "./ScriptModal.css";

export function ScriptModal(props: ScriptModalProps) {
  const theme = useMantineTheme();

  const [scriptEditorOpened, setScriptEditorOpened] = useState<boolean>(true);
  const [scriptExecutorOpened, setScriptExecutorOpened] = useState<boolean>(false);
  const [script, setScript] = useState<string>("");


  const closeModal = () => {
    props && props.setOpened && props.setOpened(false)
    setScriptEditorOpened(true);
    setScriptExecutorOpened(false);
  }

  return (
    <div className="scriptModal-container">
      <Modal
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        opened={props.opened}
        onClose={closeModal}
        
        radius="lg"
        size="1000px"
      >
        {scriptEditorOpened && <ScriptEditor  
          closeModal={closeModal}
          setScript={setScript}
          setScriptEditorOpened={setScriptEditorOpened}
          setScriptExecutorOpened={setScriptExecutorOpened}
          {...props} 
        />}

        {scriptExecutorOpened && <ScriptExecutor
          script= {script}
          executionMode={props.kpiInfo?.executionMode}
          configuration = {props.kpiInfo.configuration}
          closeModal={closeModal}
          setScriptEditorOpened={setScriptEditorOpened}
          setScriptExecutorOpened={setScriptExecutorOpened}
        />}
      </Modal>
    </div>
  );
}
